import { TenantClientListResponseInterface } from '@interfaces/Client.interface';
import { AxiosPromise } from 'axios';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams, PaginatedResponse } from '../types';

export class ApiTenantClientExternal extends BaseApiClient {
  list(
    listData: ListDataParams,
    searchTerm?: string,
    group?: boolean
  ): AxiosPromise<PaginatedResponse<TenantClientListResponseInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      if (group) {
        listData.group = group;
      }
      this.client
        .getList('/me/client/external', listData)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  }
}

export { tenantClientExternalQueryKeys } from './query-keys';
export type { TenantClientExternalListQueryParams } from './query-keys';
export { useTenantClientExternalListQuery } from './use-tenant-client-external-queries';

